import {ModuleConfiguration} from "../router/model/UserPermission";
import {ThemeColourPickerModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const ThemeColourModuleConfiguration: ModuleConfiguration =
    new ModuleConfiguration(
        ThemeColourPickerModuleName,
        [AngularJsMaterialModuleName, ThemeColourPickerModuleName, AngularJsMaterialModuleName]
    );